import { UserStatus } from "@vega-api/generated/types/userStatus";
import { Avatar } from "@vega-core/components/Avatar/Avatar";
import { formatFullName } from "@vega-core/utils/formatString";

type Props = {
  firstName?: string;
  lastName?: string;
  email?: string;
  status?: string;
};

export const UserCell = ({ firstName, lastName, email, status }: Props) => (
  <div className="flex items-center gap-4 pointer-events-none">
    <Avatar
      initials={firstName?.[0] || email?.[0] || "?"}
      variant={status === UserStatus.ACTIVE ? "primary" : "secondary"}
    />

    <div>
      <div className="text-text/primary body-base-medium">
        {formatFullName({
          firstName: firstName ?? "",
          lastName: lastName ?? "",
        })}
      </div>
      <div className="text-text/secondary body-small-regular">{email}</div>
    </div>
  </div>
);
